import React from "react";

const PasswordInput = ({
  required,
  text,
  value,
  name,
  placeholder,
  onChange,
  onClick,
  showPassword,
}) => {
  return (
    <div className="flex flex-col">
      <label
        className="text-[0.95rem] text-[#2A2F40] font-satoshi-bold mb-2 ml-1 hidden sm:block"
        htmlFor={name}
      >
        {text}
        {required ? "*" : ""}
      </label>
      <div className="flex flex-row justify-between h-12 rounded-[1rem] p-3 bg-[#F4F5F5] items-center">
        <div className="relative h-5 w-5 mr-2 block md:hidden">
          <img src='/smallkey.svg' alt="key-icon" fill />
        </div>
        <input
          value={value}
          type={showPassword ? "text" : "password"}
          name={name}
          className="w-full outline-none border-none bg-transparent placeholder:text-[#94979F] font-satoshi text-[12px] md:text-[14px] placeholder:text-[12px] md:placeholder:text-[14px] placeholder:font-satoshi"
          onChange={onChange}
          placeholder={placeholder || "Enter here"}
          required={required}
          maxLength={20}
        ></input>
        <div className="relative h-6 w-6 cursor-pointer" onClick={onClick}>
          <img src={showPassword ? '/hiddeneye.svg' : '/eye.svg'} alt="eye-icon" fill />
        </div>
      </div>
    </div>
  );
};

export default PasswordInput;
